import { render, staticRenderFns } from "./multiUploadImg.vue?vue&type=template&id=1bbf0ecc&"
import script from "./multiUploadImg.vue?vue&type=script&lang=js&"
export * from "./multiUploadImg.vue?vue&type=script&lang=js&"
import style0 from "./multiUploadImg.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports